export default {
   INCLUDE_BPE: {
      ALL_ENTRIES: 'all_entries',
      ENTRIES_WITH_BPE: 'entries_with_bpe',
      ENTRIES_WITHOUT_BPE: 'entries_without_bpe',
   },
   DATE_TYPE: [
      { LABEL: 'Data de Evento', KEY: 'emission' },
      { LABEL: 'Data de Emissão', KEY: 'authorisation' },
   ],
   INCLUDE_BPE_TYPE: [
      { KEY: 'all_entries', LABEL: 'Todas as passagens' },
      { KEY: 'entries_with_bpe', LABEL: 'Passagens com BPE' },
      { KEY: 'entries_without_bpe', LABEL: 'Passagens sem BPE' },
   ],
   TRANSPORT_TYPE: [
      { KEY: 1, LABEL: 'Rodoviário' },
      { KEY: 3, LABEL: 'Aquaviário' },
      { KEY: 4, LABEL: 'Ferroviário' },
   ],
   SALE_TYPES: [
      { KEY: 'SELLING_POINT_BOOKED_TOKEN', LABEL: 'Passagem reservada vendida em um ponto ou terminal de vendas' },
      { KEY: 'SELLING_POINT_VEHICLE_TOKEN', LABEL: 'Passagem de veículo vendida em um ponto ou terminal de vendas' },
      { KEY: 'APP_USER_BOOKED_TOKEN', LABEL: 'Passagem de pedestre reservada comprada através do aplicativo de usuário' },
      { KEY: 'APP_USER_VEHICLE_TOKEN', LABEL: 'Passagem de veículo comprada através do aplicativo de usuário' },
   ],
};
